import { useState, useCallback } from 'react';

const STORAGE_KEY = 'dait_products';

function load() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) ?? [];
  } catch {
    return [];
  }
}

function save(products) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
}

export function useProducts() {
  const [products, setProducts] = useState(load);

  const addProduct = useCallback((data) => {
    const next = [
      ...load(),
      { ...data, id: crypto.randomUUID(), createdAt: new Date().toISOString() },
    ];
    save(next);
    setProducts(next);
  }, []);

  const updateProduct = useCallback((id, data) => {
    const next = load().map((p) => (p.id === id ? { ...p, ...data } : p));
    save(next);
    setProducts(next);
  }, []);

  const deleteProduct = useCallback((id) => {
    const next = load().filter((p) => p.id !== id);
    save(next);
    setProducts(next);
  }, []);

  return { products, addProduct, updateProduct, deleteProduct };
}
